import * as React from 'react';
import { ProductInterface } from '../../Model/Product';

interface FilterInfoProps {
    rootProducts: ProductInterface[],
    allProducts: ProductInterface[],
    filteredProducts: ProductInterface[],
}

export class FilterInfo extends React.Component<FilterInfoProps, {}> {
    public render() {
        return null;
    }
}
